
import React, { useState, useEffect, useRef } from "react";
import progressGif from "../../images/progress.gif";
import Failure_Cards_List from "./Failure_Cards_List";

const Auth_Failure_List = ({ errorCode, month, year, distCode }) => {
    const [data, setData] = useState(null);
    const [districtName, setDistrictName] = useState("");
    const [selectedRc, setSelectedRc] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchOnce = useRef(false);

    useEffect(() => {
        if (!errorCode || !month || !year || !distCode || fetchOnce.current) {
            return;
        }

        fetchOnce.current = true;
        setLoading(true);
        setError(null);
        setSelectedRc(null);

        const fetchData = async () => {
            try {
                const url =
                    `${process.env.REACT_APP_URL_HEADER}/api/authFailures/auth-failure-list` +
                    `?error_code=${encodeURIComponent(errorCode)}` +
                    `&month=${encodeURIComponent(month)}` +
                    `&year=${encodeURIComponent(year)}` +
                    `&dist_code=${encodeURIComponent(distCode)}`;

                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setData(result);
                setDistrictName(result.district_name || distCode);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [errorCode, month, year, distCode]);

    if (loading) {
        return (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <img src={progressGif} alt="Loading..." width="250" height="15" />
            </div>
        );
    }

    if (error) {
        return (
            <div align="center">
                <div className="response error">Error: {error}</div>
            </div>
        );
    }

    if (!data || !data.records || data.records.length === 0) {
        return (
            <div align="center">
                <div className="response">Details Not Found</div>
            </div>
        );
    }

    const { records, tot_auth, refresh_time } = data;

    return (
        <div style={{ marginTop: "20px" }}>
            <table align="center" id="Report" width="80%" border="1">
                <thead>
                    <tr className="tableheader">
                        <th colSpan="5">
                            {`Abstract for Error code ${errorCode} in District ${districtName}`}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th>Sl No</th>
                        <th>Office</th>
                        <th>FPS id</th>
                        <th>RC No</th>
                        <th>Total<br />Authentications</th>
                    </tr>
                </thead>

                <tbody>
                    {records.map((record, index) => (
                        <tr key={`${record.fps_id}-${record.rc_id}-${index}`}>
                            <td>{index + 1}</td>
                            <td>{record.office_name}</td>
                            <td>{record.fps_id}</td>
                            <td>
                                <button
                                    style={{ background: "none", border: "none", color: "black", cursor: "pointer" }}
                                    onClick={() => setSelectedRc(record.rc_id)}
                                >
                                    {record.rc_id}
                                </button>
                            </td>
                            <td align="right">{record.tot_auth}</td>
                        </tr>
                    ))}
                </tbody>

                <tfoot>
                    <tr className="tableheader">
                        <th colSpan="4">Total</th>
                        <th align="right">{tot_auth}</th>
                    </tr>
                    <tr align="right">
                        <td colSpan="5">
                            <b><span style={{ color: "red" }}>Last Refreshed:- </span></b>
                            <span style={{ color: "green" }}>{refresh_time}</span>
                        </td>
                    </tr>
                </tfoot>
            </table>

            {selectedRc && (
                <Failure_Cards_List
                    month={month}
                    year={year}
                    rcId={selectedRc}
                    responseCode={errorCode}
                />
            )}
        </div>
    );
};

export default Auth_Failure_List;
